// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"790c64be","732":"4870ce2f","977":"17715bba"}[chunkId] + ".chunk.js";
};